<template>
  <div class="content-page">
    <div
      class="flex flex-column align-content-start justify-content-start flex-wrap content-privacy"
      :style="{ direction: language != 'en' ? 'rtl' : 'ltr' }"
    >
      <div class="flex align-items-start title">
        {{ $t("privacy.title") }}
      </div>
      <div v-if="language == 'en'">
        <div
          class="flex flex-column align-items-start align-content-start text"
        >
          <p>Privacy Policy</p>

          <p>Effective as of 01 Aug 2023</p>

          <p>
            Welcome to the Captain Korek application (the “Captain Korek”),
            operated by TORNET COMPANY FOR GENERAL TRADING AND COMMUNICATION
            SERVICES LTD (“Company”, “we” or “us”). This Privacy Policy explains
            our online information practices regarding the information collected
            in connection with your use of the Application and any other sites,
            applications, features, content or promotions offered by us from
            time to time that link or otherwise refer to this Privacy Policy
            (collectively, the “Services”). This Privacy Policy is effective
            with respect to all information that we have collected, or in the
            future collect, from you, whether as a guest or a registered user.
          </p>

          <p>Acceptance of Privacy Policy</p>

          <p>
            Please read this Privacy Policy carefully before you start to use
            the Services. By accessing and/or using the Services, you accept and
            agree to be bound and abide by this Privacy Policy and our Terms of
            Use available at https://captainkorek.korektel.com (the “Terms of
            Use”) incorporated herein by reference and to comply with all
            applicable laws, rules and regulations (collectively, “Applicable
            Law”). If you do not want to agree to this Privacy Policy and the
            Terms of Use, you must not access or use the Services.
          </p>

          <p>Changes to Privacy Policy</p>

          <p>
            Please note that we may change this Privacy Policy from time to
            time. Any changes to this Privacy Policy will be posted to the
            Services and/or emailed to the last email address you have given to
            us and will become effective as of the earlier of the date we post
            the revised privacy policy on the Services or send the email.
          </p>

          <p>Categories of Information We Collect</p>

          <p>
            Information You Provide to Us. When you set up an account, subscribe
            to a Service, enter a tournament, sweepstakes or contest, request
            information from us, or otherwise communicate with our support
            personnel via forms, email, text, fax, or phone, you may provide us
            with information. Such information may include, for example, your
            name, email address, phone number. This may also include information
            you provide us about other people. By providing us with this
            information, you consent to this information being collected, used,
            disclosed and stored by us in accordance with this Privacy Policy.
          </p>

          <p>
            Information collected may include your browser type and version, IP
            address, time zone, device language, operating system and platform,
            your internet service provider, the pages and features that you
            visit, time spent on certain pages and features. When you access the
            Service from a mobile or other device). In addition, we may collect
            and store information locally on your device using mechanisms such
            as browser web storage and application data caches. By visiting the
            Services, you consent to the tracking of your activities and your
            use of the Services through the technologies described in this
            Privacy Policy and similar technologies that may be used or
            developed in the future. Public Information. If you post or share
            information or content on or through the Services, such as in
            comments or forums, or social media platforms and other online
            platforms, this information and any accompanying identifying
            information, will be considered non-confidential and
            non-proprietary, will be available publicly. We cannot prevent
            further use of this information once it is made public. By posting
            information or content any on or through the Services, you grant us
            and our affiliates and service providers, and each of their and our
            respective licensees, successors and assigns the right to use,
            reproduce, modify, perform, display, distribute and otherwise
            disclose to third-parties any such material for any purpose,
            including, without limitation, commercial and promotional purposes
            without additional compensation or consent. Information from Other
            Sources. We may obtain information about you on the Internet or
            through offline sources or other public or commercial sources
            including, without limitation, from the information you have
            provided on social media services or when you interact with our
            content through a social media service. If you register for or
            access the Service through a third-party service (e.g., Facebook,
            Twitter), connect the Service to a third-party service or share our
            content via a third-party service, you are authorizing us to
            collect, store, and use such information and content from the
            third-party service in accordance with this Privacy Policy. We may
            also combine your online information with information we obtain from
            our partners and from offline sources, including, without
            limitation, information that you may provide us with over the phone
            or in person.
          </p>

          <p>How We Use Your Information</p>

          <p>
            We may use your information, including, any personal information
            (i.e., information that identifies a specific person, such as mobile
            number), as follows: <br />
            To provide the Application and other Services to you and other
            users, including, without limitation, to provide you with
            information, support, products or services that you request from us.
            <br />
            To communicate with you and others, for example, to provide you with
            information, about your account or other products or services and
            notify you about issues with or changes to the Services or our
            policies. You agree that Company or our agents may email, call or
            text you regarding your account or your transactions and that we may
            listen to and record phone conversations you have with us, for
            example, for training purposes or to evaluate the quality of our
            service. To market and promote the Services or our other promotions,
            products and services to you, including, jointly with third-party
            marketing partners. <br />
            To allow you to publish or share content and information. <br />
            To display and target advertisements and content on the Services and
            on third-party services. <br />
            In combination with information we obtain from other sources,
            including, without limitation, offline sources. <br />
            To analyze and improve the Services and your user experience on the
            Services, including, personalization of the Services, and to develop
            new Services. <br />
            To comply with Applicable Law, including, without limitation, tax
            regulations. <br />
            To carry out our obligations and enforce our rights arising from any
            contracts entered into between you and us, including, for billing
            and collection. <br />
            To protect the rights and safety of ourselves and others, including
            to verify your account and to detect, investigate and prevent
            activities that violate our Terms of Use or are otherwise
            fraudulent, illegal or harmful. <br />
            To fulfill any other purpose for which you provide the information
            or otherwise consent. <br />
          </p>

          <p>How We Share Your Information</p>

          <p>
            To allow service providers, agents and other third-parties to assist
            in providing and managing the Services. <br />
            To provide information to our representatives, advisors, corporate
            affiliates and business partners. <br />
            With our third-party sponsors and marketing partners in connection
            with co-promotions or for their own use. <br />
            To publish or share content or information when you choose to use
            publication or sharing features of the Services. <br />
            To provide advertising on the Services and third-party sites and
            services. <br />
            In connection with a business transaction, for example, an
            acquisition, merger, sale of an asset or line of business, corporate
            reorganization or bankruptcy. <br />
            For legal and law enforcement purposes, for example, to relevant tax
            authorities, in response to a court order, subpoena or law
            enforcement agency request, to prevent fraud or abuse of the
            Services or protect the safety of ourselves or others. <br />
            When you have otherwise provided your consent to do so. <br />
            For information that does not identity you as a specific person, we
            may use and share it with third-parties for any purpose. <br />
          </p>

          <p>Feedback</p>

          <p>
            If you submit suggestions, ideas, enhancement requests,
            recommendations or other feedback (collectively, “Feedback”) in
            connection with the Services, Company will have the unrestricted
            right to use or act upon such Feedback and such Feedback will not be
            considered confidential.
          </p>

          <p>Accuracy and Updates to Personal Information</p>

          <p>
            You may contact us at info@Captainkorek.com if at any time you would
            like to see the personal information we hold about you, or to ask us
            to correct or update this information, or to ask us to delete it. To
            the extent that you provide us with current information, we do our
            best to keep your information accurate and up-to-date. We will make
            good faith efforts to make requested changes in any active database
            as soon as practicable.
          </p>

          <p>Your Choices</p>

          <p>
            Marketing Communications. If you do not wish to receive any further
            marketing communications from us, you may opt-out by clicking the
            unsubscribe link or following the instructions included in the
            communication. Please note, however, that you cannot opt-out of
            certain administrative communications from us.
          </p>

          <p>
            Ad Choices. Some advertisements and other content may be delivered
            by third-party advertising networks and advertisers that may use
            cookies and similar and/or your advertiser ID for mobile devices to
            collect and track information such as demographic information,
            inferred interests, aggregated information, and activity to assist
            them in delivering advertising that is more relevant to your
            interests. To find out more about third-party advertising networks
            and similar entities that use these technologies. Do Not Track
            Signals. At this time, we do not respond to browser ‘Do Not Track’
            signals.
          </p>

          <p>
            Not Providing Personal Information. You may choose not to provide
            personal information to us. However, if you do not provide personal
            information, parts of the Services will not be available to you.
          </p>

          <p>
            Your California Privacy Rights. California Civil Code Section §
            1798.83 permits users of the Services that are California residents
            to opt-out of our disclosure of personal information to
            third-parties for their direct marketing purposes. To make such a
            request, send an e-mail with the subject line “California Privacy
            Rights” to https://captainkorek.korektel.com and include your full
            name, email and postal address. In addition, any California resident
            under the age of eighteen (18) who has publicly posted content or
            information on the Services can request removal by sending an email
            with subject line “California Content Removal” to Torliga.com and
            include your full name, email, postal address, a description of
            where the content or information is posted and a statement that you
            posted it. We will make good faith efforts to comply with such
            requests with respect to content or information posted on the
            Services. However, please be aware that there may be circumstances
            where we are unable to remove such content or where the law does not
            require or allow such removal even if requested.
          </p>

          <p>
            EU Data Subject Rights. If you are a resident of the European
            Economic Area, under the legislation applicable to you, you may be
            entitled to exercise some or all of the following rights:
          </p>

          <p>
            to require (1) access to and/or duplicates of your personal data
            retained (in a structured, commonly used and machine readable
            format), (2) receive the personal data concerning you, which you
            have provided to us, in a structured, commonly used and
            machine-readable format and (3) to transmit those data to another
            controller without hindrance from our side and where technically
            feasible, the right of data portability (i.e., to have the personal
            data transmitted directly from us to another controller);
          </p>

          <p>
            to request proper rectification, erasure or restriction of your
            personal data, for example, because (1) it is incomplete or
            inaccurate, (2) it is no longer needed for the purposes for which it
            was collected, (3) the consent on which the processing was based has
            been withdrawn, or (4) you have objected to the data processing as
            set forth below; if the personal data is processed by third-parties,
            your request for rectification, erasure or restriction will be
            forwarded also to such third-parties unless this proves impossible
            or involves disproportionate effort;
          </p>

          <p>
            to refuse to provide and, without impact to data processing
            activities that have taken place before such withdrawal or to any
            other existing legal justification of the processing activity in
            question, withdraw your consent to processing of your personal data
            at any time;
          </p>

          <p>
            to object, based on grounds relating to your particular situation,
            to your personal data’s processing, and for use for direct marketing
            purposes, you may object at any time;
          </p>

          <p>
            to take legal actions in relation to any potential breach of your
            rights regarding the processing of your personal data, including,
            lodge complaints before the applicable supervisory authority; and
          </p>

          <p>
            to not to be subject to any decision based solely on automated
            processing, including profiling which produce legal effects
            concerning you or similarly significantly affects you.
          </p>

          <p>
            To make a request with us or for more information about your ability
            to access your personal data, you may contact us at Torliga.com. We
            may request additional information to verify your identity,
            including a correct email address or further identification.
          </p>

          <p>Delete Personal Information</p>

          <p>
            User can delete his/her personal information by contacting our
            support team at info@Captainkorek.com and ask for their information
            to be deleted.
          </p>

          <p>Information Security</p>

          <p>
            We use commercially reasonable security technologies and procedures
            to help protect your personal information from unauthorized access,
            use or disclosure. However, no one can guarantee the complete safety
            of your information. It is your responsibility to keep your account
            information confidential. If you are using a shared computer, you
            should always log out before leaving the Services to protect access
            to your information from subsequent users.
          </p>

          <p>Data Retention and International Transfer and Processing</p>

          <p>
            We will retain your information for the period necessary to fulfill
            the purpose for which it was collected and as outlined in this
            Privacy Policy unless a longer retention period is required or
            allowed by Applicable Law. However, it is not always possible to
            completely remove or delete all of your information due to technical
            constraints, contractual, financial or legal requirements. Remember
            that even after you cancel your account, copies of some information
            from your account may remain viewable in some circumstances where,
            for example, you have shared information for collaboration or with
            social media or other services. We may also retain backup
            information related to your account on our servers for some time
            after cancelation for record keeping, fraud detection or to comply
            with Applicable Law or our internal security policies. The Services
            are hosted and operated in United States. By using the Services or
            otherwise providing information to us, you understand and consent to
            having any personal information transferred to and processed in the
            United States. United States data protection and other relevant laws
            may not be the same as those in your jurisdiction if you are located
            outside of the United States, including, without limitation, in the
            European Economic Area. In certain circumstances law enforcement or
            regulatory agencies, courts or security authorities in the United
            States may be entitled to access your personal information. If you
            are a user located outside the United States, please read this
            privacy policy with care.
          </p>

          <p>Third-Party Services</p>

          <p>
            Other applications, websites and services to that we link to,
            through which you access the Services, or share information from the
            Services that are not owned or controlled by us are not subject to
            the terms of this Privacy Policy. Any visit you make to those other
            services is at your own risk. Some third-parties that support the
            Service, including by providing advertising or other services, such
            as analytics, may use tracking technologies to collect information
            about your use of the Service or other third-party services. We do
            not control these third-party technologies or services and their use
            is governed by the privacy policies of third-parties using such
            technologies. Such third-party’s use of any information you share is
            governed by the third-party’s privacy policy.
          </p>

          <p>Contact Information</p>

          <p>
            For questions or comment about this privacy policy or our privacy
            practices, please contact us at: info@Captainkorek.com
          </p>
        </div>
      </div>
      <div v-if="language == 'ar'">
        <div
          class="flex flex-column align-items-start align-content-start text"
        >
          <p>سياسة الخصوصية</p>

          <p>ساري من تاريخ 1 أب 2023</p>

          <p>
            اهلا بك في تطبيق كابتن كورك ("Captain Korek")، الذي تديره شركة تورنت
            الخاصة للتجارة ش.م.ل ("الشركة" أو "نحن"). تهدف سياسةُ الخصوصية هذه
            إلى مساعدتك على تعريف المعلومات التي نجمعها فيما يتعلق باستخدامك
            للتطبيق وأي مواقع أو تطبيقات أو ميزات أو محتوى أو عروض ترويجية أخرى
            نقدمها من وقت لآخر والتي تربط أو تشير إلى سياسة الخصوصية هذه (يشار
            لها بشكل جماعي "الخدمات"). تعتبر سياسة الخصوصية هذه فعالة فيما يتعلق
            بجميع المعلومات التي جمعناها أو سنجمعها منك في المستقبل، سواء كنت
            زائرا أو مستخدمًا مسجلاً.
          </p>

          <p>قبول سياسة الخصوصية</p>
          <p>
            يرجى قراءة سياسة الخصوصية هذه بعناية قبل استخدام الخدمات. عند
            استخدامك لخدماتنا، فأنت تقبل و توافق على الالتزام بسياسة الخصوصية
            هذه وشروط الاستخدام المتاحة على https://captainkorek.korektel.com
            ("شروط الاستخدام") المذكورة هنا، كما يجب عليك اتباع جميع القوانين و
            القواعد واللوائح القانونية (يشار إليها بشكل جماعي بـ "القانون
            المطبق"). إذا كنت لا ترغب في الموافقة على سياسة الخصوصية وشروط
            الاستخدام هذه، فلا يجب عليك استخدام خدماتنا.
          </p>

          <p>التغييرات في سياسة الخصوصية</p>

          <p>
            يرجى الملاحظة أننا قد نقوم بتغيير سياسة الخصوصية هذه من وقت لآخر.
            سيتم نشر أي تغييرات في سياسة الخصوصية هذه على الخدمات و/أو إرسالها
            عبر البريد الإلكتروني إلى آخر عنوان بريد إلكتروني قدمته لنا وستصبح
            سارية اعتبارًا من تاريخ نشر سياسة الخصوصية المنقحة على الخدمات أو
            البريد الإلكتروني.
          </p>

          <p>فئات المعلومات التي نجمعها</p>

          <p>
            المعلومات التي تقدمها لنا: يمكنك تزويدنا بالمعلومات عندما تقوم
            بانشاء حساب، أو الاشتراك في خدمة، أو الدخول في مسابقة، أو قرعة، أو
            طلب معلومات منا، أو التواصل مع موظفي الدعم لدينا عبر البريد
            الإلكتروني أو الرسائل النصية أو الفاكس أو الهاتف. قد تتضمن هذه
            المعلومات، على سبيل المثال، اسمك وعنوان بريدك الإلكتروني ورقم هاتفك.
            قد يشمل هذا أيضًا المعلومات التي تزودنا بها عن أشخاص آخرين. من خلال
            تزويدنا بهذه المعلومات، فإنك توافق على جمعنا لهذه المعلومات
            واستخدامها والكشف عنها وتخزينها وفقًا لسياسة الخصوصية هذه. قد تتضمن
            المعلومات التي يتم جمعها نوع المتصفح والإصدار وعنوان الـIP والمنطقة
            الزمنية ولغة الجهاز ونظام التشغيل والنظام الأساسي ومزود خدمة
            الإنترنت والصفحات التي تزورها والميزات المعينة والوقت الذي تقضيه في
            الصفحات عند الوصول إلى الخدمة من هاتف محمول أو جهاز آخر. بالإضافة
            إلى ذلك، يجوز لنا جمع المعلومات وتخزينها محليًا على جهازك باستخدام
            آليات مثل تخزين الويب في المتصفح وذاكرة التخزين المؤقت لبيانات
            التطبيق. من خلال زيارة الخدمات، فإنك توافق على تتبع أنشطتك واستخدامك
            للخدمات من خلال التقنيات الموضحة في سياسة الخصوصية هذه والتقنيات
            المماثلة التي يمكن استخدامها أو تطويرها في المستقبل. معلومات عامة:
            إذا قمت بنشر أو مشاركة معلومات أو محتوى على الخدمات أو من خلالها،
            كالتعليقات أو المنتديات، أو منصات الوسائط الاجتماعية وغيرها من
            المنصات عبر الإنترنت، فإن هذه المعلومات وأي معلومات تعريفية اخرى
            ستعتبر غير سرية وغير مملوكة، وتكون عامة. لا يمكننا منع الاستخدام
            الاضافي لهذه المعلومات حالما يتم نشرها. من خلال نشر المعلومات أو
            المحتوى على أي من الخدمات أو من خلالها، فإنك تمنحنا والشركات التابعة
            لنا ومقدمي الخدمات، وكل من صاحبي الرخصة التابعين لنا ولهم حق استخدام
            وإعادة إنتاج والتعديل والأداء والعرض والتوزيع والكشف لأطراف ثالثة عن
            أي من هذه المواد لأي غرض، بما في ذلك الأغراض التجارية والترويجية دون
            تعويض أو موافقة إضافية. معلومات من مصادر أخرى: قد نحصل على معلومات
            عنك على الإنترنت أو من خلال مصادر غير متصلة بالإنترنت أو مصادر عامة
            أو تجارية أخرى، مثل المعلومات التي قدمتها على خدمات الوسائط
            الاجتماعية أو عندما تتفاعل مع المحتوى الخاص بنا من خلال خدمة وسائل
            التواصل الاجتماعي. إذا قمت بالتسجيل في الخدمة أو الوصول إليها من
            خلال خدمة جهة خارجية (على سبيل المثال، فيسبوك و تويتر)، أو قمت بربط
            الخدمة بخدمة جهة خارجية أو مشاركة المحتوى الخاص بنا عبر خدمة تابعة
            لجهة خارجية، فأنت تمنحنا الإذن لجمع وتخزين واستخدام هذه المعلومات
            والمحتوى وفقًا لسياسة الخصوصية هذه. قد نقوم أيضًا بدمج معلوماتك عبر
            الإنترنت مع المعلومات التي نحصل عليها من شركائنا ومن المصادر غير
            المتصلة بالإنترنت، بما في ذلك المعلومات التي قد تزودنا بها عبر
            الهاتف أو شخصيًا.
          </p>

          <p>كيف نستخدم معلوماتك</p>
          <p class="m-2">
            • قد نستخدم معلوماتك، التي تشمل أي معلومات شخصية (المعلومات التي
            تحدد هوية شخص معين، مثل رقم الهاتف المحمول)، على النحو التالي:
            <br />
            • لتوفير التطبيق والخدمات الأخرى لك وللمستخدمين الآخرين، بما في ذلك
            تزويدك بالمعلومات أو الدعم أو المنتجات أو الخدمات التي تطلبها منا.
            <br />
            • للتواصل معك ومع الآخرين، لتزويدك على سبيل المثال بمعلومات حول
            حسابك أو منتجات أو خدمات أخرى وإخطارك بالمشكلات أو التغييرات التي
            تحدث على الخدمات أو سياساتنا. أنت توافق على أنه يجوز للشركة أو
            لوكلائنا إرسال بريد إلكتروني أو الاتصال بك أو إرسال رسائل نصية إليك
            بخصوص حسابك أو معاملاتك وأنه يجوز لنا الاستماع إلى المحادثات
            الهاتفية التي أجريتها معنا وتسجيلها، وهذا لأغراض التدريب أو لتقييم
            جودة خدماتنا.<br />
            • لتسويق وترويج خدماتنا أو عروضنا الترويجية ومنتجاتنا وخدماتنا
            الأخرى لك، بما في ذلك الاشتراك مع شركاء التسويق الخارجيين.<br />
            • للسماح لك بنشر أو مشاركة المحتوى والمعلومات.<br />
            • لعرض الإعلانات والمحتوى واستهدافهما خدماتنا وعلى خدمات الجهات
            الخارجية.<br />
            • بالاضافة الى المعلومات التي نحصل عليها من مصادر أخرى، بما في ذلك
            المصادر غير المتصلة بالإنترنت.<br />
            • لتحليل وتحسين الخدمات وتجربة المستخدم على الخدمات، بما في ذلك
            تخصيص الخدمات وتطوير خدمات جديدة.<br />
            • للامتثال للقانون المطبق، بما في ذلك اللوائح الضريبية.<br />
            • لتنفيذ التزاماتنا وإنفاذ حقوقنا من أي عقود مبرمة بينك وبيننا، بما
            في ذلك الفواتير والتحصيل.<br />
            • لحماية حقوق وسلامة أنفسنا وغيرنا، بما في ذلك التحقق من حسابك
            والكشف والتحقيق ومنع الأنشطة التي تنتهك شروط الاستخدام لدينا أو تكون
            احتيالية أو غير قانونية أو ضارة.<br />
            • لتحقيق أي غرض آخر تقدم من أجله المعلومات أو توافق على تقديمه بأي
            طريقة أخرى.<br />
          </p>

          <p>كيف نشارك معلوماتك</p>
          <p class="m-2">
            • للسماح لمزودي الخدمات والوكلاء والجهات الخارجية الأخرى بالمساعدة
            في توفير الخدمات وإدارتها.<br />
            • لتوفير المعلومات لممثلينا ومستشارينا والشركات التابعة لنا وشركاء
            الأعمال.<br />
            • مع رعاتنا الخارجيين وشركاء التسويق فيما يتعلق بالترويج المشترك أو
            لاستخدامهم الخاص.<br />
            • لنشر أو مشاركة محتوى أو معلومات عندما تختار استخدام ميزات النشر أو
            المشاركة في الخدمات.<br />
            • لتقديم إعلانات على الخدمات ومواقع وخدمات طرف ثالث.<br />
            • فيما يتعلق بمعاملة تجارية، على سبيل المثال، الاستحواذ أو الاندماج
            أو بيع ممتلكات أو خط أعمال أو إعادة تنظيم الشركة أو الإفلاس.<br />
            • للأغراض القانونية وإنفاذ القانون، على سبيل المثال للسلطات الضريبية
            ذات الصلة، استجابةً لأمر محكمة أو أمر استدعاء أو طلب وكالة إنفاذ
            القانون، لمنع الاحتيال أو إساءة استخدام الخدمات أو حماية سلامتنا أو
            سلامة الآخرين.<br />
            • عندما تكون قد قدمت موافقتك على القيام بذلك.<br />
            • بالنسبة للمعلومات التي لا تحدد هويتك كشخص معين، يجوز لنا استخدامها
            ومشاركتها مع أطراف ثالثة لأي غرض.<br />
            • التعليقات • إذا قمت بإرسال اقتراحات أو أفكار أو طلبات تحسين أو
            توصيات أو تعليقات أخرى (يشار إليها بشكل جماعي باسم "التعليقات") فيما
            يتعلق بالخدمات، فسيكون للشركة الحق باستخدام هذه التعليقات أو التصرف
            بها ولن تعتبر هذه التعليقات سرية.<br />
          </p>
          <p>الدقة في المعلومات الشخصية وتحديثها</p>

          <p>
            يمكنك الاتصال بنا على info@Captainkorek.com إذا كنت ترغب في أي وقت
            في الاطلاع على المعلومات الشخصية التي نحتفظ بها عنك، أو تطلب منا
            تصحيح هذه المعلومات أو تحديثها، أو مطالبتنا بحذفها. إلى الحد الذي
            تزودنا فيه بالمعلومات الحالية، فإننا نبذل قصارى جهدنا للحفاظ على دقة
            معلوماتك وتحديثها. سنبذل اقصى جهودنا لإجراء التغييرات المطلوبة في أي
            قاعدة بيانات نشطة في أقرب وقت ممكن عمليًا.
          </p>

          <p>اختياراتك</p>

          <p>
            الاتصالات التسويقية: إذا كنت لا ترغب في تلقي أي اتصالات تسويقية أخرى
            منا، فيمكنك إلغاء الاشتراك عن طريق نقر رابط إلغاء الاشتراك أو اتباع
            الإرشادات الواردة في الاتصال. يرجى ملاحظة انه لا يمكنك إلغاء
            الاشتراك في بعض الاتصالات الإدارية منا. خيارات الإعلان: قد يتم تقديم
            بعض الإعلانات والمحتويات الأخرى بواسطة شبكات الإعلان والمعلنين
            التابعة لجهات خارجية والتي قد تستخدم ملفات تعريف الارتباط وما شابهها
            و/أو رمز تعريف المعلن لك او الأجهزة المحمولة لجمع وتتبع المعلومات
            مثل المعلومات الديموغرافية والاهتمامات المستنتجة والمعلومات المجمعة
            ومساعدتهم في تقديم إعلانات أكثر صلة باهتماماتك. عدم تقديم معلومات
            شخصية: يمكنك اختيار عدم تقديم معلومات شخصية لنا. ومع ذلك، إذا لم
            تقدم معلومات شخصية، فلن تتوفر لك أجزاء من الخدمات. حقوق كاليفورنيا
            الخصوصية: يسمح قسم القانون المدني لولاية كاليفورنيا (§ 1798.83)
            لمستخدمي الخدمات المقيمين في كاليفورنيا بعدم الكشف عن المعلومات
            الشخصية لأطراف خارجية لأغراض التسويق المباشر الخاصة بهم. لتقديم مثل
            هذا الطلب، عليك إرسال بريد إلكتروني بعنوان "حقوق الخصوصية في
            كاليفورنيا" إلى https://captainkorek.korektel.com الذي يشمل اسمك
            الكامل والبريد الإلكتروني والعنوان البريدي. بالإضافة إلى ذلك، يمكن
            لأي مقيم في كاليفورنيا تحت سن الثامنة عشرة (18) قام بنشر محتوى أو
            معلومات عامة عن الخدمات طلب الإزالة عن طريق إرسال بريد إلكتروني
            بالعنوان "إزالة محتوى كاليفورنيا" إلى
            https://captainkorek.korektel.com الذي يحتوي اسمك بالكامل والبريد
            الإلكتروني، والعنوان البريدي، ووصف لمكان نشر المحتوى أو المعلومات
            وبيان أنك قمت بنشره. سنبذل جهودًا حسنة النية للامتثال لهذه الطلبات
            فيما يتعلق بالمحتوى أو المعلومات المنشورة على الخدمات. يرجى العلم
            أنه مع ذلك، قد تكون هناك ظروف يتعذر علينا فيها إزالة هذا المحتوى أو
            حيث لا يتطلب القانون أو يسمح بمثل هذا الإزالة حتى إذا طُلب ذلك. حقوق
            البيانات في الاتحاد الأوروبي: إذا كنت مقيمًا في المنطقة الاقتصادية
            الأوروبية، بموجب التشريع المطبق عليك، فقد يحق لك ممارسة بعض أو كل من
            الحقوق التالية:
          </p>

          <p class="m-2">
            • المطالبة (1) بالوصول إلى و/أو نسخ بياناتك الشخصية المحفوظة (بتنسيق
            منظم وشائع الاستخدام وقابل للقراءة آليًا) ، (2) بتلقي البيانات
            الشخصية المتعلقة بك، والتي قدمتها لنا بتنسيق منظم وشائع الاستخدام
            وقابل للقراءة آليًا و (3) بنقل هذه البيانات إلى وحدة تحكم أخرى دون
            عائق من جانبنا وحيثما يكون ذلك ممكنًا تقنيًا، الحق في نقل البيانات
            (أي نقل البيانات الشخصية مباشرة منا إلى وحدة تحكم أخرى)؛ • طلب
            التصحيح المناسب لبياناتك الشخصية أو محوها أو تقييدها، على سبيل
            المثال، بسبب (1) أنها غير كاملة أو غير دقيقة، (2) لم تعد ضرورية
            للأغراض التي تم جمعها، (3) تم سحب الموافقة على المعالجة، أو (4)
            اعترضت على معالجة البيانات على النحو المبين أدناه؛ إذا تمت معالجة
            البيانات الشخصية من قبل جهات خارجية، فسيتم أيضًا إرسال طلبك للتصحيح
            أو المحو أو التقييد إلى هذه الأطراف الخارجية ما لم يثبت ذلك مستحيلًا
            أو يتطلب جهد غير معقول؛ • رفض تقديم بياناتك او سحب موافقتك على
            معالجة بياناتك الشخصية في أي وقت (ودون التأثير على أنشطة معالجة
            البيانات التي تمت قبل هذا الانسحاب أو أي مبرر قانوني آخر لنشاط
            المعالجة المذكور)؛ • الاعتراض، بناءً على أسباب تتعلق بوضعك الخاص،
            على معالجة بياناتك الشخصية، ولاستخدامها لأغراض التسويق المباشر،
            يمكنك الاعتراض في أي وقت؛ • اتخاذ إجراءات قانونية فيما يتعلق بأي
            انتهاك محتمل لحقوقك فيما يتعلق بمعالجة بياناتك الشخصية، بما في ذلك
            تقديم الشكاوى أمام السلطات الرسمية؛ و • عدم الخضوع لأي قرار يعتمد
            فقط على المعالجة الآلية، بما في ذلك إنشاء ملفات تعريف من معلوماتك
            الشخصية الذي ينتج عنه تأثيرات قانونية تتعلق بك أو يؤثر عليك بشكل
            كبير. لتقديم طلب أو للحصول على مزيد من المعلومات حول قدرتك على
            الوصول إلى بياناتك الشخصية، يمكنك الاتصال بنا على
            https://captainkorek.korektel.com. قد نطلب معلومات إضافية للتحقق من
            هويتك، بما في ذلك عنوان بريد إلكتروني صحيح أو المزيد من التعريف.
          </p>

          <p>حذف المعلومات الشخصية</p>

          <p>
            يمكن للمستخدم حذف معلوماته الشخصية عن طريق الاتصال بفريق الدعم لدينا
            على info@Captainkorek.com وطلب حذف معلوماته.
          </p>

          <p>أمن المعلومات</p>

          <p>
            نحن نستخدم تقنيات وإجراءات أمنية شائعة تجاريًا لكي نحمي معلوماتك
            الشخصية من الوصول أو الاستخدام أو الكشف الغير مصرح به. ومع ذلك، لا
            يمكن لأحد أن يضمن السلامة الكاملة لمعلوماتك. تقع على عاتقك مسؤولية
            الحفاظ على سرية معلومات حسابك. إذا كنت تستخدم جهاز كمبيوتر مشتركًا،
            فيجب عليك دائمًا تسجيل الخروج قبل مغادرة الخدمات لحماية الوصول إلى
            معلوماتك من المستخدمين اللاخرين.
          </p>

          <p>الاحتفاظ بالبيانات ونقلها ومعالجتها دوليًا</p>

          <p>
            سنحتفظ بمعلوماتك للفترة اللازمة لتحقيق غرض جمعها وعلى النحو المبين
            في سياسة الخصوصية هذه ما لم يكن هناك حاجة إلى فترة احتفاظ أطول أو
            مسموح بها بموجب القانون المطبق. ومع ذلك، ليس من الممكن دائمًا إزالة
            أو حذف جميع معلوماتك بالكامل بسبب القيود التقنية أو المتطلبات
            التعاقدية أو المالية أو القانونية. تذكر أنه حتى بعد إلغاء حسابك،
            ستبقى نسخ من بعض المعلومات من حسابك التي ستكون قابلة للعرض في بعض
            الظروف حيث، على سبيل المثال، قمت بمشاركة معلومات بالتعاون أو مع
            وسائل التواصل الاجتماعي أو خدمات أخرى. قد نحتفظ أيضًا بالمعلومات
            الاحتياطية المتعلقة بحسابك على خادم الويب (السيرفر) لفترة قليلة بعد
            الإلغاء لحفظ السجلات أو اكتشاف الاحتيال أو الامتثال للقانون المطبق
            أو سياسات الأمان الداخلية لنا. يتم استضافة الخدمات وتشغيلها في
            الولايات المتحدة: باستخدام الخدمات أو تقديم المعلومات إلينا بطريقة
            أخرى، فإنك تفهم وتوافق على نقل أي معلومات شخصية إلى الولايات المتحدة
            ومعالجتها فيها. قد لا تكون قوانين حماية البيانات الأمريكية والقوانين
            الأخرى ذات الصلة هي نفسها تلك الموجودة في نطاق سلطتك القضائية إذا
            كنت متواجدًا خارج الولايات المتحدة، بما في ذلك، على سبيل المثال،
            المنطقة الاقتصادية الأوروبية. في ظروف معينة، قد يحق للوكالات
            القانونية أو الهيئات التنظيمية أو المحاكم أو السلطات الأمنية في
            الولايات المتحدة الوصول إلى معلوماتك الشخصية. إذا كنت مستخدمًا خارج
            الولايات المتحدة، فيرجى قراءة سياسة الخصوصية هذه بعناية.
          </p>

          <p>خدمات الاطراف الخارجية</p>

          <p>
            التطبيقات والمواقع الإلكترونية والخدمات الأخرى ذات صلة لنا، والتي من
            خلالها تصل إلى الخدمات، أو تشارك المعلومات من الخدمات التي لا
            نمتلكها أو نسيطر عليها، لا تخضع لشروط سياسة الخصوصية هذه. أي زيارة
            تقوم بها لتلك الخدمات الأخرى تكون على مسؤوليتك. قد تستخدم بعض الجهات
            الخارجية التي تدعم الخدمة (بما في ذلك عن طريق تقديم الإعلانات أو
            الخدمات الأخرى، مثل التحليلات) تقنيات التتبع لجمع معلومات حول
            استخدامك للخدمة أو خدمات الاطراف الخارجية الأخرى. نحن لا نتحكم في
            تقنيات أو خدمات الاطراف الخارجية هذه ويخضع استخدامها لسياسات
            الخصوصية الخاصة بالاطراف الخارجية التي تستخدم هذه التقنيات. يخضع
            استخدام هذه الاطراف الخارجية لأي معلومات تشاركها لسياسة الخصوصية
            الخاصة بها.
          </p>

          <p>معلومات الاتصال</p>

          <p>
            للسؤال أو التعليق حول سياسة الخصوصية هذه أو قواعد الخصوصية لدينا،
            يرجى الاتصال بنا على: info@Captainkorek.com
          </p>
        </div>
      </div>
      <div v-if="language == 'ku'">
        <div
          class="flex flex-column align-items-start align-content-start text"
        >
          <p>سیاسەتی پاراستنی نهێنی</p>

          <p>لە 1ی ئابى 2023ەوە کاری پێدەکرێت</p>

          <p>
            بەخێربێن بۆ ئەپڵیکەیشنی کابتن کورەك ("Captain Korek")، کە لەلایەن
            کۆمپانیای کەرتی تایبەت تورنێت بۆ بازرگانی گشتی سنووردار ("کۆمپانیا"،
            "ئێمە") بەڕێوەدەبرێت. ئەم سیاسەتەی پاراستنی نهێنی بە مەبەستی
            یارمەتیدانی تۆیە بۆ ئەوەی تێبگەیت کە ئێمە چ زانیارییەک کۆدەکەینەوە
            سەبارەت بە بەکارهێنانی ئەپڵیکەیشنەکەتدا و هەر سایتێک، ئەپڵیکەیشنێک،
            تایبەتمەندییەک، ناوەڕۆک یان بانگەشەکردنێکی تر کە لەلایەن ئێمەوە
            جارجارە پێشکەش دەکرێت کە دەبەسترێتەوە یان بە شێوەیەکی تر ئاماژە بە
            سیاسەتی پاراستنی نهێنی دەکات (بە کۆ “خزمەتگوزارییەکان”). ئەم
            سیاسەتەی پاراستنی نهێنی کاریگەرە سەبارەت بە هەموو ئەو زانیاریانەی کە
            ئێمە لە تۆ کۆمان کردۆتەوە، یان لە داهاتوودا کۆی دەکەینەو، جا وەک
            سەردانیکارێک بیت یان بەکارهێنەرێکی تۆمارکراو.
          </p>

          <p>قبوڵکردنی سیاسەتی پاراستنی نهێنی</p>

          <p>
            تکایە پێش ئەوەی دەست بکەیت بە بەکارهێنانی خزمەتگوزارییەکان ئەم
            سیاسەتەی پاراستنی نهێنی بە وردی بخوێنەرەوە. بە دەستگەیشتن و/یان
            بەکارهێنانی خزمەتگوزارییەکان، تۆ قبوڵ دەکەیت و ڕەزامەندیت لەسەر
            پابەندبوون بەم سیاسەتەی پاراستنی نهێنی و مەرجەکانی بەکارهێنانمان کە
            لە https://captainkorek.korektel.com ("مەرجەکانی بەکارهێنان")
            بەردەستە کە لێرەدا ئاماژەیان پێکراوە و و پابەندیت بە هەموو یاسا و
            ڕێسا کارپێکراوەکان (بە شێوەیەکی گشتی، "یاسای کارپێکراو"). ئەگەر تۆ
            ناتەوێت بەم سیاسەتەی پاراستنی نهێنی و مەرجەکانی بەکارهێنان ڕازی بیت،
            نابێت خزمەتگوزارییەکان بەکار بهێنیت.
          </p>

          <p>گۆڕانکاری لە سیاسەتی پاراستنی نهێنی</p>

          <p>
            تکایە ئاگاداربە کە ڕەنگە جارجارە ئەم سیاسەتەی پاراستنی نهێنی بگۆڕین.
            هەر گۆڕانکارییەک لەم سیاسەتەی پاراستنی نهێنیدا لەسەر
            خزمەتگوزارییەکان بڵاودەکرێتەوە و/یان بە ئیمەیڵ دەنێردرێت بۆ دوا
            ناونیشانی ئیمەیڵ کە تۆ پێت داوین و لە بەرواری بڵاوکردنەوەی سیاسەتی
            پاراستنی نهێنی پێداچوونەوەکراو لەسەر خزمەتگوزارییەکان یان ئیمەیڵی
            نێردراو بەردەست دەبێت.
          </p>

          <p>پۆلەکانی ئەو زانیاریانەی کە کۆیان دەکەینەوە</p>

          <p>
            ئەو زانیاریانەی کە تۆ پێمان دەدەیت: دەتوانیت زانیاریمان پێ بدەیت
            کاتێک ئەکاونتێک دادەنێیت، یان بەشداریدەکەیت لە خزمەتگوزارییەک، یان
            بەشداری پێشبڕکێیەک یان تیروپشکێک دەکەیت، یان داوای زانیاری لە ئێمە
            دەکەیت، یان پەیوەندی لەگەڵ ڕاژەی بەشداربووانمان دەکەیت لە ڕێگەی
            فۆڕم، ئیمەیڵ، پەیام، فاکس یان تەلەفۆنەوە. ئەم زانیاریانە لەوانەیە بۆ
            نموونە ناو و ناونیشانی ئیمەیڵ و ژمارەی تەلەفۆنەکەت بیت. هەروەها
            لەوانەیە ئەمە ئەو زانیاریانەش بگرێتەوە کە تۆ سەبارەت بە کەسانی دیکە
            پێمان دەدەیت. بە پێدانی ئەو جۆرە زانیاریانە بە ئێمە، تۆ ڕەزامەندیت
            لەسەر کۆکردنەوە، بەکارهێنانیان، ئاشکراکردن و هەڵگرتنی ئەو جۆرە
            زانیاریانە بەپێی ئەم سیاسەتەی پاراستنی نهێنی. لەوانەیە ئەو زانیاریە
            کۆکراوەکان بریتی بن لە جۆری براوزەر، ڤێرژن، ناونیشانی IP، ناوچەی
            کاتی، زمانی ئامێر، سیستەمی کارپێکردن و پلاتفۆڕم، دابینکەری
            خزمەتگوزاری ئینتەرنێت، ئەو لاپەڕە و تایبەتمەندیانەی کە سەردانیان
            دەکەیت، و ئەو کاتەی کە لە هەندێک لاپەڕە و تایبەتمەندیدا بەسەری
            دەبەیت لەکاتی چوونە ناو خزمەتگوزارییەکە لە مۆبایلێک یان ئامێرێکی
            ترەوە. سەرەڕای ئەوە، ڕەنگە ئێمە زانیارییەکان بە شێوەیەکی ناوخۆیی
            لەسەر ئامێرەکەت کۆبکەینەوە و هەڵیبگرین بە بەکارهێنانی میکانیزمەکانی
            وەک هەڵگرتنی زانیاری ناو براوزەر و کاشی داتاکانی بەرنامەکە. بە
            سەردانیکردنی خزمەتگوزارییەکان، تۆ ڕەزامەندیت لەسەر بەدواداچوونی
            چالاکییەکانت و بەکارهێنانی خزمەتگوزارییەکان لەلایەن ئەو
            تەکنەلۆژیایانەی کە لە سیاسەتی پاراستنی نهێنیدا باسکراون و تەکنەلۆژیا
            هاوشێوەکان کە لەوانەیە لە داهاتوودا بەکاربهێنرێن یان پەرەیان
            پێبدرێت.
          </p>

          <p>
            زانیاری گشتی: ەگەر تۆ زانیاری یان ناوەڕۆک لە خزمەتگوزارییەکان یان لە
            ڕێگەی خزمەتگوزارییەکانەوە بڵاو بکەیتەوە یان هاوبەشی بکەیت، وەک لە
            کۆمێنتەکان، کۆڕەکان، پلاتفۆرمی سۆشیال میدیا و پلاتفۆرمە ئۆنلاینەکانی
            تر، ئەو جۆرە زانیاریانە و هەر زانیارییەکی هاوشێوەی بە نهێنی هەژمار
            ناکرێت و مافی خاوەنداریەتی نابێت، و بەردەست دەبێت بۆ هەموو
            بەکارهێنەران. ئێمە ناتوانین ڕێگری لە بەکارهێنانی زیاتری ئەم
            زانیاریانە بکەین کاتێک بڵاوکرانەوە. بە بڵاوکردنەوەی زانیاری یان
            ناوەڕۆک لەسەر یان لە ڕێگەی هەریەکێک لە خزمەتگوزارییەکانەوە، تۆ مافی
            بەکارهێنان، بەرهەمهێنانەوە، دەستکاریکردن، ئەنجامدان، پێشکەشکردن،
            دابەشکردن و ئاشکراکردنی بۆ لایەنی سێیەم دەدەیت بە ئێمە، لقەکانمان،
            دابینکەرانی خزمەتگوزارییەکانمان، و هەریەک لە و مۆڵەتدەرەکانمان،
            ئەوەش بۆ هەر مەبەستێک، لەوانەش مەبەستی بازرگانی و بانگەشە، بەبێ
            قەرەبووکردنەوە یان ڕەزامەندی زیادە. زانیاری لە سەرچاوەی ترەوە:
            لەوانەیە ئێمە زانیاری دەربارەی تۆ بە شێوەی ئۆنلاین، لە ڕێگەی ئۆفلاین
            یان سەرچاوە گشتی یان بازرگانییەکانی ترەوە بەدەست بهێنین، لە
            زانیارییەکانی کە تۆ لە خزمەتگوزارییەکانی سۆشیال میدیا پێشکەشت کردووە
            یان کاتێک کە تۆ ناوەڕۆکەکەمان بەکاربهێنی لە ڕێگەی خزمەتگوزاری سۆشیال
            میدیا. ئەگەر تۆ ناوت تۆمار بکەیت یان لە ڕێگەی خزمەتگوزاری لایەنی
            سێیەمەوە (بۆ نموونە، فەیسبووک و تویتەر) دەستت بگات بە
            خزمەتگوزارییەکە، یان هەستای بە بەستەوەی خزمەتگوزارییەکە بە
            خزمەتگوزاری لایەنی سێیەم یان ناوەڕۆکەکەمان لە ڕێگەی خزمەتگوزاری
            لایەنی سێیەمەوە هاوبەش بکەیت، ئەوا تۆ ڕێگەمان پێدەدەیت بە کۆکردنەوە
            و هەڵگرتن و بەکارهێنانی ئەو جۆرە زانیاری و ناوەڕۆکانەی
            بەدەستیاندێنین لە لایەنی سێیەمەوە بە پێی ئەم سیاسەتی پاراستنی
            نهێنیە. هەروەها ڕەنگە ئێمە زانیارییە ئۆنلاینەکانی تۆ تێکەڵ بکەین
            لەگەڵ ئەو زانیاریانەی کە لە هاوبەشەکانمان و سەرچاوە ئۆفلاینەکانەوە
            بەدەستمان هێناون، لەوانە ئەو زانیاریانەی کە ڕەنگە لە ڕێگەی
            تەلەفۆنەوە یان بە شێوەیەکی کەسی پێمان بدەیت.
          </p>

          <p>چۆن زانیارییەکانت بەکاردەهێنین</p>

          <p>
            لەوانەیە ئێمە زانیارییەکانی تۆ بەکاربهێنین، وەک هەر زانیارییەکی کەسی
            (واتە ئەو زانیاریانەی کە کەسێکی دیاریکراو دەناسێتەوە، وەک ژمارەی
            مۆبایل)، بەم شێوەیەی خوارەوە:
          </p>

          <p class="m-2">
            • بۆ پێشکەشکردنی بەرنامەکە و خزمەتگوزارییەکانی تر بۆ تۆ و
            بەکارهێنەرانی تر بۆ دابینکردنی زانیاری، پشتگیری، بەرهەم یان ئەو
            خزمەتگوزاریانەی کە تۆ داوای لە ئێمە دەکەیت. • بۆ پەیوەندیکردن لەگەڵ
            تۆ و کەسانی دیکە، بۆ نموونە، بۆ پێدانی زانیاری دەربارەی ئەکاونتەکەت
            یان بەرهەم یان خزمەتگوزارییەکانی تر و ئاگادارکردنەوەت لە کێشەکان یان
            گۆڕانکارییەکان لە خزمەتگوزارییەکان یان سیاسەتەکانمان. تۆ ڕەزامەندیت
            لەسەر ئەوەی کە کۆمپانیا یان بریکارەکانمان دەتوانن ئیمەیڵ یان نامەت
            بۆ بنێرن یان پەیوەندیت پێوە بکەن سەبارەت بە ئەکاونتەکەت یان
            مامەڵەکانت و لەوانەیە ئێمە گوێ لە گفتوگۆ تەلەفۆنییەکانت بگرین و
            تۆماریان بکەین کە لەگەڵ ئێمەدا دەکەیت، بۆ نموونە، بە مەبەستی فێرکردن
            یان بۆ هەڵسەنگاندنی کوالیتی خزمەتگوزارییەکانمان. • بۆ ڕێکلامکردن و
            پەرەپێدانی خزمەتگوزارییەکانمان یان بانگەشە و بەرهەم و
            خزمەتگوزارییەکانی ترمان بۆ تۆ، لەوانەش بە هاوکاری هاوبەشە
            بازرگانەکانی لایەنی سێیەم. • بۆ ئەوەی ڕێگەت پێبدات ناوەڕۆک و زانیاری
            پۆست بکەیت یان هاوبەشی بکەیت. • بۆ پیشاندان و ئامانجکردنی ڕێکلام و
            ناوەڕۆک لەسەر خزمەتگوزارییەکانمان و لەسەر خزمەتگوزارییەکانی لایەنی
            سێیەم. • ئەو زانیاریانەی لە سەرچاوەی ترەوە بەدەستی دەهێنین سەرچاوەی
            ئۆفلاین. • بۆ شیکردنەوە و باشترکردنی خزمەتگوزارییەکان و ئەزموونی
            بەکارهێنەر لەسەر خزمەتگوزارییەکان، لەوانەش تەرخانکردنی
            خزمەتگوزارییەکان بۆ بەکارهێنەران و پەرەپێدانی خزمەتگوزاری نوێ. • بۆ
            پابەندبوون بە یاسای کارپێکراو، لەوانەش ڕێساکانی باج. • بۆ
            جێبەجێکردنی ئەرکەکانمان و جێبەجێکردنی مافەکانمان کە لە هەر
            گرێبەستێکەوە سەرهەڵدەدات کە لە نێوان تۆ و ئێمەدا کراوە، لەوانەش
            پسولە و کۆکردنەوەی پارە. • بۆ پاراستنی ماف و سەلامەتی خۆمان و کەسانی
            دیکە، لەوانەش پشتڕاستکردنەوەی ئەکاونتەکەت و دۆزینەوە، لێکۆڵینەوە و
            ڕێگریکردن لەو چالاکییانەی کە مەرجەکانی بەکارهێنانمان پێشێل دەکەن یان
            ساختەکاری، نایاسایی یان زیانبەخشن. • بۆ بەدیهێنانی هەر مەبەستێکی تر
            کە تۆ زانیارییەکانتان داوە یان ڕەزامەندیتان دەربڕیوە بۆ پێدانی
            زانیارییەکان.
          </p>

          <p>چۆن زانیارییەکانتان هاوبەش دەکەین</p>

          <p class="m-2">
            • بە ڕێگەدان بە پێشکەشکارانی خزمەتگوزاری، بریکارەکان و لایەنە
            سێیەمەکانی تر کە یارمەتیدەر بن لە پێشکەشکردن و بەڕێوەبردنی
            خزمەتگوزارییەکان. • بە پێدانی زانیاری بە نوێنەرانمان، ڕاوێژکارانمان،
            ئەو کۆمپانیانەی سەر بە ئێمەن و هاوبەشە بازرگانییەکانمان. • لەگەڵ
            سپۆنسەرەکانی لایەنی سێیەم و هاوبەشە بازرگانییەکانمان سەبارەت بە
            ڕیکلام کردنی هاوبەش یان بۆ بەکەرهێنانی کەسی. • بۆ بڵاوکردنەوە یان
            هاوبەشکردنی ناوەڕۆک یان زانیاری کاتێک تایبەتمەندییەکانی بڵاوکردنەوە
            یان هاوبەشکردنی خزمەتگوزارییەکان هەڵدەبژێریت کە بەکاریبهێنیت. • بۆ
            پێشکەشکردنی ڕیکلام لە خزمەتگوزارییەکان و سایت و خزمەتگوزارییەکانی
            لایەنی سێیەم. • ئەو شتانەی پەیوەندی بە مامەڵەی بازرگانیدا هەیە، بۆ
            نموونە، بەدەستهێنان، کۆکردن، یان فرۆشتنی سەروەت و سامان یان هێڵی
            بازرگانی یان ڕێکخستنەوەی کۆمپانیا یان ئیفلاس. • بۆ مەبەستی یاسایی و
            جێبەجێکردنی یاسا، بۆ نموونە، بۆ دەسەڵاتە باجییە پەیوەندیدارەکان، لە
            وەڵامی فەرمانی دادگا، بانگهێشتنامە یان داواکاری وەکالەتی جێبەجێکردنی
            یاسا، بۆ ڕێگریکردن لە ساختەکاری یان خراپ بەکارهێنانی
            خزمەتگوزارییەکان یان پاراستنی سەلامەتی خۆمان یان کەسانی دیکە. •
            کاتێک کە تۆ ڕەزامەندی خۆت داوە بۆ ئەنجامدانی ئەم کارە. • سەبارەت بەو
            زانیاریانەی کە تۆ وەک کەسێکی دیاریکراو ناناسێنن،دەتوانین بۆ هەر
            مەبەستێک بەکاریان بهێنین و لەگەڵ کەسانی سێیەمدا هاوبەشی بکەین. •
            فیدباک • ئەگەر تۆ پێشنیار، بیرۆکە، داواکاری باشترکردن، یان سەرنجێکی
            تر (بە کۆ "فیدباک") کە پەیوەندیدارە بە خزمەتگوزارییەکان، کۆمپانیا
            مافی بێسنووری دەبێت بۆ بەکارهێنانی ئەم فیدباکانە، و ئەو فیدباکانە بە
            نهێنی نازانرێت.
          </p>

          <p>وردبینی و نوێکردنەوەی زانیاری کەسی</p>

          <p>
            دەتوانیت پەیوەندیمان پێوە بکەیت بەم ئیمەیڵە info@Captainkorek.com
            ئەگەر لە هەر کاتێکدا بتەوێت ئەو زانیارییە کەسییانەی کە ئێمە لەبارەی
            تۆوە لەبەردەستمانە ببینیت، یان داوای ڕاستکردنەوە یان نوێکردنەوەی ئەم
            زانیاریانەمان لێبکەیت، یان داوای سڕینەوەیمان لێبکەیت. تا ئەو ڕادەیەی
            کە تۆ زانیاریی ئێستامان پێدەدەیت، ئێمە هەموو هەوڵێک دەدەین بۆ ئەوەی
            بە وردی پارێزگاری لە زانیارییەکانتان بکەین و هەردەم نوێی دەکەینەوە.
            ئێمە باشترین هەوڵی خۆمان دەدەین بۆ ئەوەی بە زووترین کات گۆڕانکاری
            داواکراو لە هەر داتابەیسیێکی چالاکدا بکەین.
          </p>

          <p>هەڵبژاردنەکانت</p>

          <p>
            پەیوەندیەکانی مارکێتینگ: ئەگەر تۆ ناتەوێت هیچیتر نامەی مارکێتینگ لە
            ئێمەوە وەربگریت، دەتوانیت بەشداریکردن هەڵوەشێنیتەوە بە کلیك کردن
            لەسەر لینکی وەستاندنی بەشداریکردن یان جێبەجێکردنی ئەو ڕێنماییانەی کە
            لە نامەکەدا هاتووە. بەڵام تکایە ئاگاداربە کە ناتوانیت لە هەندێک
            پەیوەندی کارگێڕی لەلایەن ئێمەوە بوەستێنیت.
          </p>

          <p>
            هەڵبژاردەی ڕێکلامەکان: ڕەنگە هەندێک لە ڕێکلامەکان و ناوەڕۆکەکانی تر
            لەلایەن تۆڕەکانی ڕێکلامی لایەنی سێیەم و ڕێکلامکەرانەوە بگەیەنرێن کە
            لەوانەیە "کووکی" و هاوشێوەکانیان یان ناسنامەی ڕێکلامی ئامێری
            مۆبایلەکەت بەکاربهێنن بۆ کۆکردنەوە و بەدواداچوونی زانیارییەکانی
            دیمۆگرافی، بەرژەوەندییە دەرکەوتووەکان، زانیاری کۆکراوە و چالاکییەکان
            بۆ گەیاندنی ئەو ڕیکلامانەی کە زیاتر پەیوەندییان بە تۆوە هەیە.
          </p>

          <p>
            نەدانی زانیاری کەسی: دەتوانیت ئەوە هەڵبژێریت کە زانیاری کەسیمان پێ
            نەدەیت. بەڵام ئەگەر تۆ زانیاری کەسی نەدەیت، بەشێک لە
            خزمەتگوزارییەکان بۆت بەردەست نابن.
          </p>

          <p>
            مافەکانی پاراستنی نهێنی کالیفۆرنیا: بەشی یاسای مەدەنی کالیفۆرنیا (§
            1798.83) ڕێگە بە بەکارهێنەرانی کالیفۆرنیا دەدات کە زانیارییە
            کەسییەکانیان بۆ لایەنی سێیەم ئاشکرا نەکەن بۆ مەبەستی بازرگانی
            ڕاستەوخۆیان. بۆ پێشکەشکردنی داواکارییەکی لەو جۆرە، ئیمەیڵێک بنێرە بە
            ناوی "مافی نهێنی کالیفۆرنیا" بۆ https://captainkorek.korektel.com و
            ناوی تەواو و ئیمەیڵ و ناونیشانی پۆستی خۆت بنووسە. سەرەڕای ئەوە، هەر
            دانیشتوویەکی کالیفۆرنیا لە خوار تەمەنی هەژدە (18) ساڵەوە کە بە
            ئاشکرا ناوەڕۆک یان زانیاری لەسەر خزمەتگوزارییەکان بڵاوکردبێتەوە،
            دەتوانێت داوای لابردنی بکات بە ناردنی ئیمەیڵێک بە ناوی "لابردنی
            ناوەڕۆکی کالیفۆرنیا" بۆ https://captainkorek.korektel.com لەگەڵ ناوی
            تەواوی تۆ و ناونیشانی ئیمەیڵەکەت، ناونیشانی پۆست، وەسفێک بۆ
            ناوەڕۆکەکە یان لە کوێ زانیارییەکان بڵاودەکرێنەوە و بەیاننامەیەک کە
            تۆ بڵاوت کردۆتەوە. ئێمە باشترین هەوڵ دەدەین بۆ پابەندبوون بەم جۆرە
            داواکاریانە سەبارەت بە ناوەڕۆک یان ئەو زانیاریانەی کە لەسەر
            خزمەتگوزارییەکان بڵاوکراونەتەوە. بەڵام تکایە ئاگاداربن کە لەوانەیە
            بارودۆخێک هەبێت کە ئێمە نەتوانین ئەو جۆرە ناوەڕۆکە لاببەین یان یاسا
            داوای لابردنی لەو جۆرە نەکات یان ڕێگەی پێنادات تەنانەت ئەگەر داواش
            بکرێت.
          </p>

          <p>
            مافی خاوەندارێتی داتاکان لە یەکێتی ئەوروپا: ئەگەر تۆ دانیشتووی
            ناوچەی ئابووری ئەوروپا بیت، بەپێی ئەو یاسایانەی کە بۆت کارپێکراوە،
            مافی ئەوەت دەبێت هەندێک یان هەموو ئەم مافانەی خوارەوە بەکاربهێنیت:
          </p>
          <p class="m-2">
            • داواکردنی (1) بەکارهێنانی زانیارییە کەسییەکانی هەڵگیراو (بە
            فۆرماتێکی ڕێک و باو بێت بۆ بەکارهێنان و ئامادەبێت بخوێندرێتەوە بە
            ئامێر)، (2) وەرگرتنی زانیارییە کەسییەکانی پەیوەست بە تۆ کە تۆ
            پێتداوین، بە فۆرماتێکی ڕێک و باو بێت بۆ بەکارهێنان و ئامادەبێت
            بخوێندرێتەوە بە ئامێر (3) بۆ گواستنەوەی ئەو زانیاریانە بۆ
            کۆنترۆڵکەرێکی دیکە بەبێ کێشە لە لایەن ئێمەوە، و بە شێوەیەکی تەکنیکی
            کە دەتوانرێت جێبەجێ بکرێت، مافی گواستنەوەی داتاکان (واتە، گواستنەوەی
            زانیارییە کەسییەکان ڕاستەوخۆ لە ئێمەوە بۆ کۆنترۆڵکەرێکی دیکە)؛ •
            داواکردنی ڕاستکردنەوە، سڕینەوە یان سنووردارکردنی زانیارییە
            کەسییەکانت، بۆ نموونە، چونکە (1) ناتەواو یان نادروستە، (2) چیتر
            پێویست نییە بۆ ئەو مەبەستانەی کە بۆی کۆکراونەتەوە، (3) ئەو
            ڕەزامەندییەی نەماوە کە پرۆسێسەکە لەسەری بنیات نراوە، یان (4) تۆ
            ناڕەزایەتیت دەربڕیوە بەرامبەر بە پرۆسێسکردنی داتاکان بە شێوەی
            خوارەوە؛ ئەگەر زانیارییە کەسییەکان لەلایەن لایەنی سێیەمەوە پرۆسێس
            بکرێن، داواکارییەکەت بۆ ڕاستکردنەوە، سڕینەوە یان سنووردارکردن
            دەنێردرێت بۆ ئەو لایەنە سێیەمانە، تەنها ئەم کاتە نانێردرێت ئەگەر
            مەحاڵ بێت یان پێویستی بە هەوڵێکی زۆر هەبێت؛ • ڕەتکردنەوە و کشانەوەی
            ڕەزامەندی خۆت بۆ پرۆسێسکردنی زانیارییە کەسییەکانت لە هەر کاتێکدا،
            بەبێ کاریگەری لەسەر چالاکییەکانی پرۆسێسکردنی زانیارییەکان کە پێش
            کشانەوە ڕوویانداوە یان بۆ هەر پاساوێکی یاسایی دیکەی هەبوو بۆ چالاکیی
            پرۆسێسکردنی دیاریکراو؛ • ڕەتکردنەوە بەهۆی ئەو هۆکارانەی پەیوەستن بە
            دۆخی تایبەتی تۆ، بە پرۆسێسکردنی زانیارییە کەسییەکانت، و بۆ
            بەکارهێنان بۆ مەبەستی بازرگانی ڕاستەوخۆ، دەتوانیت لە هەر کاتێکدا
            ناڕەزایەتی خۆت دەرببڕیت؛ • گرتنەبەری ڕێوشوێنی یاسایی سەبارەت بە هەر
            پێشێلکارییەک لە مافەکانت دەربارەی بە پرۆسێسکردنی زانیارییە
            کەسییەکانت، وەک پێشکەشکردنی سکاڵا بۆ لایەنی پەیوەندیدار؛ و • نەچوونە
            ژێر هیچ بڕیارێکەوە کە تەنها لەسەر بنەمای پرۆسێسی ئۆتۆماتیکی بێت، بۆ
            نموونە پرۆفایلینگ کە کاریگەری یاسایی هەیە سەبارەت بە تۆ یان بە
            شێوەیەکی بەرچاو کاریگەری لەسەر تۆ هەیە. • داواکاریکردنی زانیاری
            زیاتر لە ئێمە سەبارەت بە توانای دەستڕاگەیشتن بە زانیارییە
            کەسییەکانت، دەتوانیت پەیوەندیمان پێوە بکەیت لە
            https://captainkorek.korektel.com. لەوانەیە ئێمە داوای زانیاری زیاتر
            بکەین بۆ پشتڕاستکردنەوەی ناسنامەکەت، بۆ نموونە ناونیشانی ئیمەیڵی
            دروست یان پێناسەی زیاتر.
          </p>

          <p>سڕینەوەی زانیاری کەسی</p>

          <p>
            بەکارهێنەر دەتوانێت زانیارییە کەسییەکانی خۆی بسڕێتەوە بە
            پەیوەندیکردن بە تیمی ڕاژەی بەشداربووان لە info@Captainkorek.com و
            داوای سڕینەوەی زانیارییەکان بکات.
          </p>

          <p>ئاسایشی زانیاری</p>

          <p>
            ئێمە تەکنەلۆژیا و ڕێکارە ئەمنییەکانی بازرگانی گونجاو بەکاردەهێنین بۆ
            یارمەتیدانی پاراستنی زانیارییە کەسییەکانت، لە بەکارهێنان یان
            ئاشکراکردنی بێ مۆڵەت. بەڵام هیچ کەسێک ناتوانێت گەرەنتی سەلامەتی
            تەواوی زانیارییەکانتان بکات. پاراستنی نهێنی زانیارییەکانی
            ئەکاونتەکەت دەکەوێتە ئەستۆی تۆ. ئەگەر کۆمپیوتەرێکی هاوبەش
            بەکاردەهێنیت، پێویستە هەمیشە بچیتە دەرەوەی ئەکاونتەکەت پێش ئەوەی
            خزمەتگوزارییەکان دابخەی بۆ پاراستنی زانیارییەکانت لە بەکارهێنەرانی
            دواتر.
          </p>

          <p>هەڵگرتنی زانیاریەکان و گواستنەوە و پرۆسێسکردنی نێودەوڵەتی</p>

          <p>
            ئێمە زانیارییەکانتان بۆ ماوەیەکی پێویست هەڵدەگرین بۆ ئەو مەبەستەی کە
            بۆی کۆکراونەتەوە و وەک لەم بەڵگەنامەیەدا ئاماژەی پێکراوە، ئەوەش
            تەنها مەگەر ماوەی هەڵگرتنی درێژتر بەپێی یاسا پێویست نەبێت یان ڕێگەی
            پێبدات. بەڵام هەمیشە ناتوانرێت هەموو زانیارییەکانتان بە تەواوی
            لاببرێن یان بسڕێنەوە بەهۆی سنووری تەکنیکی یان مەرجە گرێبەستییەکان و
            داراییەکان و یاساییەکان. لەبیرت بێت کە تەنانەت دوای هەڵوەشاندنەوەی
            ئەکاونتەکەت، ڕەنگە کۆپی هەندێک زانیاری لە ئەکاونتەکەتەوە ئاشکارا بێت
            کە بۆ نموونە هاوبەش کردووە لە سۆشیال میدیا یان خزمەتگوزارییەکانی تر.
            هەروەها زانیاری باک ئەپ (backup)ی ئەکاونتەکەت هەڵدەگرین لە
            سێرڤەرەکانماندا بۆ ماوەیەک دوای هەڵوەشاندنەوە بۆ پاراستنی تۆمارەکان،
            دیاریکردنی ساختەکاری، یان پابەندبوون بە یاسا یان سیاسەتەکانی ئاسایشی
            ناوخۆییمان.
          </p>

          <p>
            خزمەتگوزارییەکان لە ئەمریکا بەڕێوەدەبرێن: بە بەکارهێنانی
            خزمەتگوزارییەکان یان پێدانی زانیاری بە ئێمە بە شێوەیەکی تر، تۆ
            ڕەزامەندیت لەسەر گواستنەوە و پرۆسێسکردنی هەر زانیارییەکی کەسی بۆ
            ئەمریکا. یاسای پاراستنی زانیارییەکانی ئەمریکا و یاساکانی دیکەی
            هاوشێوەی لەوانەیە بۆ تۆ وەک یەک نەبن ئەگەر لە دەرەوەی ئەمریکا بیت،
            وەک لە ناوچەی ئابووری ئەوروپا. لەوانەیە لە هەندێک بارودۆخدا
            دەزگاکانی یاسایی یان چاودێری یان دەسەڵاتە ئەمنییەکان لە ئەمریکا مافی
            ئەوەیان هەبێت دەستیان بە زانیارییە کەسییەکانی تۆ بگات. ئەگەر تۆ
            بەکارهێنەرێک بیت لە دەرەوەی ئەمریکا، تکایە ئەم سیاسەتەی پاراستنی
            نهێنی بە وردییەوە بخوێنەرەوە. خزمەتگوزاریەکانی لایەنی سێیەم بەرنامە،
            ماڵپەڕ و خزمەتگوزارییەکانی تر کە پەیوەندییان بە ئێمەوە هەیە پابەند
            نین بە مەرجەکانی ئەم سیاسەتەی پاراستنی نهێنی، کە لە ڕێگەیانەوە تۆ
            دەستت دەگاتە خزمەتگوزارییەکان، یان زانیارییەکانی ئەو خزمەتگوزارییانە
            هاوبەش دەکەن کە خاوەندارێتی یان کۆنترۆڵکردنی ئێمە نین. هەر سەردانێک
            کە بۆ ئەو خزمەتگوزارییانەی تر بکەیت، لەسەر ئەستۆی خۆتە. لەوانەیە
            هەندێک لە لایەنە سێیەمەکان کە پشتگیری لە خزمەتگوزارییەکە دەکەن (بۆ
            پێشکەشکردنی ڕێکلام یان خزمەتگوزارییەکانی تر، وەک شیکاری) تەکنەلۆژیای
            بەدواداچوون بەکاربهێنن بۆ کۆکردنەوەی زانیاری سەبارەت بە بەکارهێنانی
            خزمەتگوزارییەکە یان خزمەتگوزارییەکانی تری لایەنی سێیەم. ئێمە ئەم
            تەکنەلۆژیا یان خزمەتگوزاریانەی لایەنی سێیەم کۆنتڕۆڵ ناکەین و
            بەکارهێنانیان بەپێی سیاسەتی نهێنی لایەنی سێیەم بەڕێوەدەچێت.
            بەکارهێنانی هەر زانیارییەک لەلایەن لایەنی سێیەمەوە کە تۆ هاوبەشی
            دەکەیت بەپێی سیاسەتی نهێنی لایەنی سێیەم بەڕێوەدەچێت.
          </p>

          <p>زانیاریی په‌یوه‌ندییكردن</p>

          <p>
            بۆ هەر پرسیارێک یان سەرنجێک سەبارەت بەم سیاسەتەی پاراستنی نهێنیە یان
            شێوازەکانی پاراستنی نهێنیمان، تکایە پەیوەندیمان پێوە بکەن بەم
            ئیمەیڵە: info@Captainkorek.com
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from "@/translation";
import { store } from "../store";

export default {
  name: "PrivacyComponent",
  components: {},
  data() {
    return {};
  },
  methods: {},
  computed: {
    language() {
      store.layout.headerTitle = this.$t("privacy.title");
      return i18n.locale;
    },
  },
  mounted() {
    store.layout.showHeader = true;
    store.layout.showFooter = false;
    store.layout.showAccountFooter = false;
    store.layout.headerTitle = this.$t("privacy.title");
  },
};
</script>

<style scoped>
.content-page {
  font-weight: 400;
  font-family: "Poppins";
  font-style: normal;
  background-color: #191b22;
}

.content-privacy {
  /* height: calc(var(--appHeight) - 140px); */
  min-height: var(--appHeight);
}

.about_card {
  background-image: url("../assets/terms_card.png");
  background-repeat: no-repeat;
  width: 350px;
  height: 140px;
  margin-bottom: 20px;
}

.title {
  font-weight: 600;
  font-size: 28px;
  color: #ffffff;
  padding-left: 40px;
  padding-right: 40px;
  margin-top: 20px;
  margin-bottom: 20px;
}

.text {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  color: #b0b1ca;
  padding-left: 40px;
  padding-right: 40px;
  text-align: left;
}
</style>
